import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Profile")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "current" }, "My Profile", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "heading-div" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "My Profile")
], -1)
const _hoisted_6 = { class: "container-xxl mb-4" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Change Details")
], -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "form-group col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Name ", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", {
  style: {"color":"red"},
  class: "error"
}, "Name is required", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "form-group col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Email", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", {
  style: {"color":"red"},
  class: "error"
}, "Email is required", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "row mt-3" }
const _hoisted_27 = { class: "form-group col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "IC Number", -1)
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("small", {
  style: {"color":"red"},
  class: "error"
}, "IC Number is required", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "form-group col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Mobile Number", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("small", {
  style: {"color":"red"},
  class: "error"
}, "Mobile Number is required", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-10" }, null, -1)
const _hoisted_41 = { class: "col-md-2 mt-4" }
const _hoisted_42 = { class: "col-md-12 mt-5 mb-4" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Change Password")
], -1)
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, "New Password", -1)
const _hoisted_49 = {
  key: 0,
  style: {"color":"red"},
  class: "error"
}
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "Confirm New Password", -1)
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("small", {
  style: {"color":"red"},
  class: "error"
}, "Confirm New Password is required", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("small", {
  style: {"color":"red"},
  class: "error"
}, "New Password does not match with Confirm Password", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = { key: 2 }
const _hoisted_61 = {
  style: {"color":"red"},
  class: "error"
}
const _hoisted_62 = { class: "row" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-10" }, null, -1)
const _hoisted_64 = { class: "col-md-2 mt-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'Dashboard' } }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: { name: 'CustomerProfile' } }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _hoisted_4
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer.customer_name) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control", 
                        _ctx.customerValidationTriggered &&
                        _ctx.customer.customer_name == ''
                          ? 'is-invalid'
                          : ''
                      ])
                    }, null, 2), [
                      [_vModelText, _ctx.customer.customer_name]
                    ]),
                    (
                        _ctx.customerValidationTriggered &&
                        _ctx.customer.customer_name == ''
                      )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.email) = $event)),
                      type: "email",
                      class: _normalizeClass(["form-control", 
                        _ctx.customerValidationTriggered && _ctx.customer.email == ''
                          ? 'is-invalid'
                          : ''
                      ])
                    }, null, 2), [
                      [_vModelText, _ctx.customer.email]
                    ]),
                    (_ctx.customerValidationTriggered && _ctx.customer.email == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.ic_no) = $event)),
                      type: "text",
                      readonly: "",
                      class: _normalizeClass(["form-control", 
                        _ctx.customerValidationTriggered && _ctx.customer.ic_no == ''
                          ? 'is-invalid'
                          : ''
                      ])
                    }, null, 2), [
                      [_vModelText, _ctx.customer.ic_no]
                    ]),
                    (_ctx.customerValidationTriggered && _ctx.customer.ic_no == '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customer.mobile_no) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control", 
                        _ctx.customerValidationTriggered && _ctx.customer.mobile_no == ''
                          ? 'is-invalid'
                          : ''
                      ])
                    }, null, 2), [
                      [_vModelText, _ctx.customer.mobile_no]
                    ]),
                    (
                        _ctx.customerValidationTriggered && _ctx.customer.mobile_no == ''
                      )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateCustomer && _ctx.updateCustomer(...args)))
                    }, " Change Details ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPassword) = $event)),
                        type: "password",
                        class: _normalizeClass(["form-control", 
                          _ctx.validationTriggered && _ctx.newPassword == ''
                            ? 'is-invalid'
                            : ''
                        ])
                      }, null, 2), [
                        [_vModelText, _ctx.newPassword]
                      ]),
                      (_ctx.validationTriggered && _ctx.newPassword == '')
                        ? (_openBlock(), _createElementBlock("small", _hoisted_49, "New Password is required"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmNewPassword) = $event)),
                        type: "password",
                        class: _normalizeClass(["form-control", 
                          _ctx.validationTriggered && _ctx.confirmNewPassword == ''
                            ? 'is-invalid'
                            : ''
                        ])
                      }, null, 2), [
                        [_vModelText, _ctx.confirmNewPassword]
                      ]),
                      (_ctx.validationTriggered && _ctx.confirmNewPassword == '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, _hoisted_55))
                        : _createCommentVNode("", true),
                      (
                          _ctx.validationTriggered &&
                          _ctx.newPassword != _ctx.confirmNewPassword
                        )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_59))
                        : _createCommentVNode("", true),
                      (_ctx.serverError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("small", _hoisted_61, _toDisplayString(_ctx.serverErrorMessage), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
                    }, " Change Password ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_65
  ]))
}